export default {
  methods: {
    has_roles(roles=[]){
      if (this.current_user_role_name) {
        return roles.includes(this.current_user_role_name)
      }else{
        return false
      }
    },
    isManager() {
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Manager"
      }else{
        return false
      }
    },
    isFinancial() {
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Financial"
      }else{
        return false
      }
    },
    isAnalyst() {
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Analyst"
      }else{
        return false
      }
    },
    isDirector() {
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Director"
      }else{
        return false
      }
    },
    isSeller() {
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Seller"
      }else{
        return false
      }
    },
    isSalesExecutive(){
      if (this.current_user_role_name) {
        return this.current_user_role_name == "SalesExecutive"
      }else{
        return false
      }
    },
    isClerk(){
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Clerk"
      }else{
        return false
      }
    },
    isLogistics(){
      if (this.current_user_role_name) {
        return this.current_user_role_name == "Logistics"
      }else{
        return false
      }
    },
    isCreditAnalyst(){
      if (this.current_user_role_name) {
        return this.current_user_role_name == "CreditAnalyst"
      }else{
        return false
      }
    }
  },
  computed:{
    actual_user_role_name(){
      return this.$store?.state?.User?.oneUser?.included?.[0]?.attributes?.role?.data?.[0]?.attributes?.name
    },
    current_user_role_name(){
      const viewAs = this.$store?.state?.App?.viewAsRoleName
      if (viewAs) return viewAs
      return this.actual_user_role_name
    },
    is_viewing_as_role(){
      return !!this.$store?.state?.App?.viewAsRoleName
    },
    is_actual_director(){
      return this.actual_user_role_name === 'Director'
    },
    current_user_employee_id(){
      return this.$store?.state?.User?.oneUser?.included?.[0]?.attributes?.id
    },
    current_user_employee_name(){
      return this.$store?.state?.User?.oneUser?.included?.[0]?.attributes?.name
    },
    current_user_employee(){
      return this.$store?.state?.User?.oneUser?.included?.[0]?.attributes
    },

  }
}